import { APP_DEFAULT_ADULTS } from '@common/constants';

export type JourneyParty = {
  adults?: number | null;
  children?: number | null;
};

export type DiningPartyChange = {
  adults: number;
  children: 0;
};

export function getDiningCovers({ adults, children }: JourneyParty): number {
  const covers = (Number(adults) || 0) + (Number(children) || 0);
  return covers > 0 ? covers : APP_DEFAULT_ADULTS;
}

export function getDiningPartyChange(
  covers: number,
  party: JourneyParty
): DiningPartyChange | null {
  return covers === getDiningCovers(party) ? null : { adults: covers, children: 0 };
}

export function isPartySizeRefusal(error: unknown): boolean {
  const partySize = (error as { response?: { data?: { partySize?: unknown } | null } } | null)
    ?.response?.data?.partySize;
  return Array.isArray(partySize) && partySize.length > 0;
}
